import { createAction } from '@reduxjs/toolkit';

export const spacerUpdateRequest = createAction('emailsSpacer/updateRequest');
export const spacerUpdateError = createAction('emailsSpacer/updateError');
export const spacerUpdateStore = createAction('emailsSpacer/updateStore');

export const spacerStore = createAction('emailsSpacer/store');
export const spacerClear = createAction('emailsSpacer/clear');

export const spacerUpdateId = createAction('emailsSpacer/updateId');
export const spacerUpdateIsActive = createAction('emailsSpacer/updateIsActive');

export const spacerUpdateHeight = createAction('emailsSpacer/updateHeight');
export const spacerUpdateView = createAction('emailsSpacer/updateView');
